import React from 'react'
import usePagination from '@common/hooks/usePagination'
import { Button, Flex } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'

interface PaginationPropsType {
  currentPage: number
  totalCount: number
  pageSize: number
  setCurrentPage: (page: number) => void
  scrollOptions?: ScrollToOptions
}

const PaginationButton = ({
  children,
  bg,
  color,
  disabled,
  onClick,
  _hover
}: {
  children: React.ReactNode
  bg?: string
  color?: string
  disabled?: boolean
  onClick?: () => void
  _hover?: any
}) => {
  return (
    <Button
      color={color || 'gray.600'}
      bg={bg || 'white'}
      _hover={_hover || { bg: 'white' }}
      isDisabled={disabled}
      onClick={onClick}
      borderRadius={0}
      px={{
        lg: 8,
        base: 4
      }}
    >
      {children}
    </Button>
  )
}

const Pagination = ({
  currentPage,
  totalCount,
  pageSize,
  setCurrentPage,
  scrollOptions = { top: 0, behavior: 'smooth' }
}: PaginationPropsType) => {
  const { paginationRange, totalPage } = usePagination({
    currentPage,
    totalCount,
    pageSize
  })

  const displayPagination = () => {
    if (paginationRange && paginationRange?.length > 0) {
      return paginationRange.map((v, k) => {
        if (Number.isNaN(v)) {
          return <div key={k}>...</div>
        }
        return (
          <PaginationButton
            key={k}
            bg={currentPage === v ? 'red' : 'white'}
            color={currentPage === v ? 'bg' : 'gray.600'}
            onClick={() => {
              setCurrentPage(v)
              window.scrollTo(scrollOptions)
            }}
            _hover={{ bg: 'red', color: 'bg' }}
          >
            {v}
          </PaginationButton>
        )
      })
    }
  }

  return (
    <>
      {totalCount !== 0 && (
        <Flex gap={3} alignItems={'end'} wrap={'wrap'} mt={5}>
          <PaginationButton
            disabled={currentPage === 1}
            onClick={() => {
              setCurrentPage(currentPage - 1)
            }}
          >
            <ChevronLeftIcon boxSize={7} />
          </PaginationButton>
          {displayPagination()}
          <PaginationButton
            disabled={currentPage === totalPage}
            onClick={() => {
              setCurrentPage(currentPage + 1)
            }}
            bg={'white'}
          >
            <ChevronRightIcon boxSize={7} />
          </PaginationButton>
        </Flex>
      )}
    </>
  )
}

export default Pagination
